import { createKeyedAsyncReducer } from '../../../redux-util/async-helpers';
import {
  CREATE_ADOPTION,
  DELETE_ADOPTION,
  LIST_ADOPTIONS,
} from '../../bridge-methods';
import { getAsyncReducerWithModify } from '../../bridge-async-modifier';

const itemReducer = getAsyncReducerWithModify({
  fetchKey: LIST_ADOPTIONS,
  createKey: CREATE_ADOPTION,
  deleteKey: DELETE_ADOPTION,
  appendNode: 'adoptions',
  itemParam: 'id',
  appendNodeCreate: 'adoption',
  // Single class list, show new ones at top
  appendOnCreate: false,
});

const undefinedUpdateReducer = getAsyncReducerWithModify({
  createKey: CREATE_ADOPTION,
  deleteKey: DELETE_ADOPTION,
  appendNode: 'adoptions',
  itemParam: 'id',
  appendNodeCreate: 'adoption',
  // All adoptions list (menu), show new ones at bottom
  appendOnCreate: true,
});

export default createKeyedAsyncReducer({
  actionKeys: [LIST_ADOPTIONS, CREATE_ADOPTION, DELETE_ADOPTION],
  param: 'group',
  itemReducer,
  undefinedUpdateReducer,
});



// WEBPACK FOOTER //
// ./src/app/api/redux-bridge/adoptions/list/reducer.js